import { useMutation } from "@apollo/client/react";

import { buildDisplayName, sortField } from "@smart/itops-utils-basic";
import {
  mutationDocuments,
  queryDocuments,
} from "@smart/manage-gql-operations-dom";

import { useQueryFactory } from "./base";

export const useLoadDeletedForms = useQueryFactory(
  queryDocuments.deletedForms,
  {
    map: ({ deletedForms }) =>
      sortField(
        deletedForms
          .filter((f) => !f.values.deleted)
          .map((f) => ({
            uri: f.uri,
            formTitle: f.values.title,
            formCategory: f.values.category,
            matterTypeCategories: f.values.matterTypes.map((mt) => mt.category),
            matterTypeNames: f.values.matterTypes.map((mt) => mt.name),
            matterTypeLocations: f.values.matterTypes.map((mt) => mt.location),
            matterTypeList: f.values.matterTypes
              .map((mt) => `${mt.name} - ${mt.location}`)
              .sort()
              .join(", "),
            updatedAt: f.values.updatedAt,
            createdBy: buildDisplayName(f.values.createdBy, ""),
            teamUri: f.values.teamUri,
            creationStatus: f.values.creationStatus,
            active: f.values.active ?? undefined,
            aiUserFeedback: undefined,
            aiFillSettings: undefined,
            deletedBy: buildDisplayName(f.values.deletedBy, ""),
            deletedAt: f.values.deletedAt,
            restoredAt: f.values.restoredAt,
            rawForm: f,
          })),
        {
          key: (f) => f.updatedAt,
          dir: "desc",
        },
      ),
  },
);

export const useRestoreDeletedForm = () =>
  useMutation(mutationDocuments.restoreDeletedForm, {
    update: (cache, _, { variables }) => {
      if (variables) {
        const { uri } = variables;

        cache.modify({
          id: cache.identify({ __typename: "DeletedForm", uri }),
          fields: {
            values: (existing) => ({
              ...existing,
              restoredAt: new Date().toISOString(),
            }),
          },
        });
      }
    },
  });
